import styled from 'styled-components';
import { sizes, theme } from 'theme';
import { BodyLarge, FlexColCenter, FlexColRg } from 'components/Elements';
import strings from '../../../strings/strings.json';
import YourTrainerCard from './YourTrainerCard';
import { DOCUMENTS_URL } from 'lib/_api-helpers';
import { LearnerCourseContext } from 'contextProviders/LearnerCourseContext';
import { useContext } from 'react';

export default function LearnerCoursePageFooter() {
    const { trainerInfo } = useContext(LearnerCourseContext).learnerCourse!;

    const profileImageFilepath = trainerInfo.profileImagePath
        ? `${DOCUMENTS_URL}/${trainerInfo.profileImagePath}`
        : '';

    return (
        <FooterBackground>
            <FooterInfoSection>
                <BodyLarge $inverted $bold>
                    {strings.learnerCoursePage.footerTrainerText} {trainerInfo.organisationName}
                </BodyLarge>
                <YourTrainerCard
                    profileImageFilepath={profileImageFilepath}
                    trainerName={`${trainerInfo.firstName} ${trainerInfo.lastName}`}
                    trainerBio={trainerInfo.bio}
                    trainerEmail={trainerInfo.email}
                />
            </FooterInfoSection>
        </FooterBackground>
    );
}

const FooterInfoSection = styled(FlexColRg)`
    align-items: flex-start;
    max-width: ${sizes.appMaxWidthWithoutPadding}px;
    padding: 0 ${sizes.edgePadding};
    width: 100%;
`;

const FooterBackground = styled(FlexColCenter)`
    background: ${theme.learnerFooterBackground};
    width: 100%;
    padding: ${sizes.spacingLg} 0;
`;
